import CopyrightIcon from '@mui/icons-material/Copyright'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import GitHubIcon from '@mui/icons-material/GitHub'
import './Footer.scss'

const Footer: React.FC = (): JSX.Element => {
	const actualYear = new Date().getFullYear()

	return (
		<footer className='footer'>
			<div className='footer__info-container'>
				{/* TODO: Complete this footer */}
				<div className='info-container__links'></div>

				<div className='info-container__company-mark'>
					<CopyrightIcon />
					<span>{actualYear}</span>
					<span>|</span>
					<span>All Rights Reserved</span>
				</div>

				<div className='info-container__social-media'>
					<a href='https://www.linkedin.com/in/mateusz-pocwiardowski/' target='_blank' rel='noreferrer'>
						<LinkedInIcon sx={{ fontSize: 28 }} />
					</a>
					<a href='https://github.com/MateuszPocwiardowski' target='_blank' rel='noreferrer'>
						<GitHubIcon sx={{ fontSize: 28 }} />
					</a>
				</div>
			</div>
		</footer>
	)
}

export default Footer
